import { useEffect, useState } from 'react';
import { useDiagramStore } from './state/store';

export const useReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduced(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return reduced;
};

export const usePlaybackController = (): void => {
  const status = useDiagramStore((state) => state.status);
  const advanceBy = useDiagramStore((state) => state.advanceBy);
  const pauseForVisibility = useDiagramStore((state) => state.pauseForVisibility);
  const resumeFromVisibility = useDiagramStore((state) => state.resumeFromVisibility);

  useEffect(() => {
    if (status !== 'playing') return;
    let frame = 0;
    let previous = performance.now();
    const tick = (now: number) => {
      const delta = Math.min(now - previous, 100);
      previous = now;
      advanceBy(delta);
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [status, advanceBy]);

  useEffect(() => {
    const onVisibility = () => document.hidden ? pauseForVisibility() : resumeFromVisibility();
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [pauseForVisibility, resumeFromVisibility]);
};
